import { render, staticRenderFns } from "./SliceCallToActionRow.vue?vue&type=template&id=70c29202&lang=pug&"
import script from "./SliceCallToActionRow.vue?vue&type=script&lang=js&"
export * from "./SliceCallToActionRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports